import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "@/components/ui/sonner";

// ------------------------------------------------
// PWA Install Hook (inline version)
// ------------------------------------------------
function usePWAInstall() {
  const [promptEvent, setPromptEvent] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPromptEvent(e);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = () => {
    if (promptEvent) {
      promptEvent.prompt();
      promptEvent.userChoice.finally(() => {
        setPromptEvent(null);
      });
    }
  };

  return { canInstall: !!promptEvent, install };
}

// ------------------------------------------------
// MAIN APP COMPONENT
// ------------------------------------------------
function App() {
  const { canInstall, install } = usePWAInstall();

  return (
    <div className="App relative">

      {/* Install App Button */}
      {canInstall && (
        <button
          onClick={install}
          className="
            fixed bottom-6 right-6 z-50
            bg-orange-600 text-white font-semibold
            px-4 py-2 rounded-2xl shadow-lg
            hover:bg-orange-700 active:scale-95
            transition-all duration-200
          "
        >
          Install App
        </button>
      )}

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
        </Routes>
      </BrowserRouter>

      <Toaster position="top-right" />
    </div>
  );
}

export default App;
